import React from "react";
import { useIntl } from "react-intl";
import { Box } from "@mui/material";
import TagsManage from "Modules/.common/components/TagsManage";
import { toDisplayedTags, toUnitTags } from "../utils/untaggedTags";

const Tags = (props) => {
  const { formData, setFormData } = props;
  const { messages } = useIntl();
  const displayedTags = toDisplayedTags(formData?.tags);

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <label className="input-normal-label">
          {messages["fleetModalUpdateUnit_tagsLabel"]}
        </label>
      </div>
      <Box sx={{ width: "100%", height: 308 }}>
        <TagsManage
          id="tags"
          label={messages["fleetModalUpdateUnit_addTags"]}
          placeholder={messages["search"]}
          value={displayedTags}
          multiple={true}
          enableSelectAll={false}
          required={false}
          height={308}
          mode="list"
          onlyTags={true}
          onChange={(values) => {
            setFormData({ ...formData, tags: toUnitTags(displayedTags, values) })
          }}
        />
      </Box>
    </div>
  );
};

export default Tags;
